import { useTranslation } from 'libs/i18n';
import { Button, DialogProps, Stack } from 'libs/ui';
import { useViewDialogWithdrawalAccount } from 'modules/client/common/components/sections/WithdrawalAccountsSection/FormContent/components/DialogViewWithdrawalAccountFeature/hooks/useViewDialogWithdrawalAccount';
import { DialogWithdrawalAccountFeature } from 'modules/client/common/components/sections/WithdrawalAccountsSection/FormContent/components/DialogWithdrawalAccountFeature';
import { WithdrawalAccountFormType } from 'modules/client/common/forms/withdrawalAccountForm';

interface Props extends DialogProps {
  onClose: () => void;
  initialValues: WithdrawalAccountFormType;
  readOnly?: boolean;
}

export const DialogViewWithdrawalAccountFeature = ({
  isOpen,
  onClose,
  initialValues,
  readOnly,
}: Props) => {
  const { t } = useTranslation();

  const { countries, countriesLoading } = useViewDialogWithdrawalAccount();

  return (
    <DialogWithdrawalAccountFeature
      countries={countries}
      countriesLoading={countriesLoading}
      footerActions={
        <Stack spacing={8}>
          <Button
            fullWidth
            label={t('client.client.withdrawalAccounts.backButton')}
            mode="text"
            onClick={onClose}
          />
        </Stack>
      }
      initialValues={initialValues}
      isOpen={isOpen}
      readOnly={readOnly}
      onClose={onClose}
      onSubmit={() => {}}
    />
  );
};
